export { Brandify, type BrandifyProps } from './Brandify'
import Brandify from './Brandify'
export default Brandify
